import { render, staticRenderFns } from "./Failures.vue?vue&type=template&id=d05a37e0"
import script from "./Failures.vue?vue&type=script&lang=js"
export * from "./Failures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports